import { motion } from "framer-motion";

const PageWrapper = ({ children, animateOnMount = true }) => {
  return (
    <motion.div
      initial={animateOnMount ? { opacity: 0 } : false}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2, ease: "easeInOut" }}
    >
      {children}
    </motion.div>
  );
};

export default PageWrapper;
